import { a as e } from "./cart-add-intercept-L_Xl4fqj.js";
(() => {
	let t = `[data-product-tile]`;
	if (window.DifraxProductTileQuickAddLoaded) return;
	window.DifraxProductTileQuickAddLoaded = !0;
	let n = window.Shopify?.routes?.root || `/`,
		r = n.endsWith(`/`) ? n : `${n}/`,
		i = new WeakMap(),
		a = new WeakSet(),
		o = null,
		s = () => `${r}checkout`,
		c = (e, t = window.DifraxMoneyFormat) => {
			if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(e, t);
			let n = window.Shopify?.currency?.active || `EUR`;
			return new Intl.NumberFormat(document.documentElement.lang || `nl-NL`, {
				style: `currency`,
				currency: n,
			}).format((e || 0) / 100);
		},
		l = (e) =>
			String(e || ``).replace(
				/[&<>"']/g,
				(e) =>
					({
						"&": `&amp;`,
						"<": `&lt;`,
						">": `&gt;`,
						'"': `&quot;`,
						"'": `&#39;`,
					})[e],
			),
		u = (e, { src: t, srcset: n, alt: r, hidden: i = !1 }) => {
			if (e) {
				if (i || !t) {
					(e.hidden = !0), e.removeAttribute(`srcset`);
					return;
				}
				(e.hidden = !1),
					(e.src = t),
					e.removeAttribute(`data-src`),
					e.removeAttribute(`data-srcset`),
					n ? (e.srcset = n) : e.removeAttribute(`srcset`),
					r !== void 0 && (e.alt = r);
			}
		},
		d = (e) => {
			e.querySelectorAll(`[data-deferred-product-image]`).forEach((e) => {
				e.dataset.src &&
					((e.src = e.dataset.src),
					e.dataset.srcset && (e.srcset = e.dataset.srcset),
					e.removeAttribute(`data-src`),
					e.removeAttribute(`data-srcset`),
					e.removeAttribute(`data-deferred-product-image`));
			});
		},
		f = (e, t) => {
			let n = e.querySelector(`.product-tile__image--hover`);
			if (n || !t) return n;
			let r = e.querySelector(`[data-product-tile-media-link]`);
			return r
				? ((n = document.createElement(`img`)),
					(n.className = `product-tile__image product-tile__image--hover`),
					(n.loading = `lazy`),
					(n.hidden = !0),
					r.append(n),
					n)
				: null;
		},
		p = (e, t) => {
			e.querySelectorAll(`[data-product-tile-swatch]`).forEach((e) => {
				let n = e === t;
				e.classList.toggle(`is-active`, n),
					e.setAttribute(`aria-pressed`, String(n));
			});
		},
		m = (e, t) => {
			let n = e.querySelector(`[data-product-tile-variant-input]`);
			if (!t) {
				delete e.dataset.selectedVariantId, n && (n.value = ``);
				return;
			}
			(e.dataset.selectedVariantId = String(t)), n && (n.value = String(t));
		},
		h = (e) =>
			e.dataset.selectedVariantId ||
			e.querySelector(`[data-product-tile-variant-input]`)?.value,
		g = (e, t) => {
			let n = t.selectedOptions?.[0],
				r = n?.value || ``,
				i = e.querySelector(`[data-product-tile-quick-add]`),
				a = e.querySelector(`[data-cart-recommendation-current-price]`),
				o = e.querySelector(`[data-cart-recommendation-compare-price]`),
				s = e.querySelector(`.cart-recommendation-card__image`),
				c = e.querySelector(`[data-cart-recommendation-media-link]`),
				l = e.querySelector(`[data-cart-recommendation-title-link]`),
				u = e.querySelector(`[data-cart-recommendation-add-label]`),
				d = e.querySelector(`[data-cart-recommendation-error]`);
			if (
				(m(e, r),
				d && ((d.textContent = ``), (d.hidden = !0)),
				i &&
					((i.disabled = !r || n?.dataset.variantAvailable !== `true`),
					n?.dataset.variantUrl &&
						(i.dataset.productUrl = n.dataset.variantUrl),
					n?.dataset.variantImage &&
						((i.dataset.productImage = n.dataset.variantImage),
						(i.dataset.productImageAlt = n.dataset.variantImageAlt || ``))),
				u && i)
			) {
				let e =
					(n?.dataset.variantInCart === `true` && i.dataset.addAnotherLabel) ||
					i.dataset.addToCartLabel;
				(u.textContent = e),
					i.setAttribute(
						`aria-label`,
						`${e || ``} - ${i.dataset.productTitle || ``}`,
					);
			}
			r &&
				(a &&
					n?.dataset.variantPrice &&
					(a.textContent = n.dataset.variantPrice),
				o &&
					((o.textContent = n?.dataset.variantComparePrice || ``),
					(o.hidden = !n?.dataset.variantComparePrice)),
				s &&
					n?.dataset.variantImage &&
					((s.src = n.dataset.variantImage),
					s.removeAttribute(`srcset`),
					(s.alt = n.dataset.variantImageAlt || ``)),
				c && n?.dataset.variantUrl && (c.href = n.dataset.variantUrl),
				l && n?.dataset.variantUrl && (l.href = n.dataset.variantUrl));
		},
		_ = (e) => {
			if (!e.matches(`[data-cart-recommendation-card]`)) return;
			let t = e.closest(`[data-cart-drawer-recommendations-track]`);
			return {
				addedMessage: e.dataset.labelAdded || `Added to your cart`,
				productId: e.dataset.productId || ``,
				productTitle:
					e
						.querySelector(
							`[data-product-tile-title-link], [data-cart-recommendation-title-link]`,
						)
						?.textContent?.trim() || ``,
				scrollLeft: t?.scrollLeft || 0,
			};
		},
		v = (() => {
			let e = !1,
				t = 0;
			return () => {
				e ||
					((e = !0),
					window.setTimeout(() => {
						if (((e = !1), typeof window.StampedFn?.loadBadges == `function`)) {
							(t = 0), window.StampedFn.loadBadges();
							return;
						}
						(t += 1), t < 20 && v();
					}, 250));
			};
		})(),
		y = (e, t) => {
			if (!t.dataset.variantId) return;
			let n = e.querySelector(`.product-tile__image--primary`),
				r = f(e, t.dataset.hoverSrc),
				i = e.querySelector(`.product-tile__image--mobile-gallery`),
				a = e.querySelector(`.product-tile__image--mobile-featured`),
				o = e.querySelector(`[data-product-tile-media-link]`),
				s = e.querySelector(`[data-product-tile-title-link]`),
				c = e.querySelector(`[data-product-tile-quick-add]`),
				l = e.querySelector(`.product-tile__rating`);
			p(e, t),
				t.dataset.primarySrc &&
					u(n, {
						src: t.dataset.primarySrc,
						srcset: t.dataset.primarySrcset,
						alt: t.dataset.primaryAlt,
					}),
				u(r, {
					src: t.dataset.hoverSrc,
					srcset: t.dataset.hoverSrcset,
					alt: t.dataset.hoverAlt,
					hidden: !t.dataset.hoverSrc,
				}),
				u(i, {
					src: t.dataset.mobileGallerySrc,
					srcset: t.dataset.mobileGallerySrcset,
					alt: t.dataset.mobileGalleryAlt,
					hidden: !t.dataset.mobileGallerySrc,
				}),
				u(a, {
					src: t.dataset.mobileFeaturedSrc,
					srcset: t.dataset.mobileFeaturedSrcset,
					alt: t.dataset.mobileFeaturedAlt,
					hidden: !t.dataset.mobileFeaturedSrc,
				}),
				o?.classList.toggle(
					`product-tile__media--has-secondary`,
					!!t.dataset.hoverSrc,
				),
				o && t.dataset.variantUrl && (o.href = t.dataset.variantUrl),
				s && t.dataset.variantUrl && (s.href = t.dataset.variantUrl),
				s &&
					e.dataset.fixedVariantCard === `true` &&
					t.dataset.variantCardTitle &&
					((s.textContent = t.dataset.variantCardTitle),
					o?.setAttribute(`aria-label`, t.dataset.variantCardTitle),
					l?.setAttribute(
						`aria-label`,
						`${t.dataset.variantCardTitle} reviews`,
					)),
				m(e, t.dataset.variantId),
				c &&
					((c.disabled = t.dataset.variantAvailable === `false`),
					t.dataset.variantUrl && (c.dataset.productUrl = t.dataset.variantUrl),
					t.dataset.primarySrc &&
						((c.dataset.productImage = t.dataset.primarySrc),
						(c.dataset.productImageAlt =
							t.dataset.primaryAlt || t.dataset.variantCardTitle || ``)),
					t.dataset.variantCardTitle &&
						((c.dataset.productTitle = t.dataset.variantCardTitle),
						c.setAttribute(
							`aria-label`,
							`${c.dataset.addToCartLabel || ``} - ${t.dataset.variantCardTitle}`,
						)));
		},
		b = (e) => ({
			added: e?.dataset.labelAdded || `Added to your cart`,
			cartError:
				e?.dataset.labelCartError || `Could not add this item. Try again.`,
			cartTitle: e?.dataset.labelCartTitle || `Cart`,
			checkout: e?.dataset.labelCheckout || `Checkout`,
			closeCart: e?.dataset.labelCloseCart || `Close cart`,
			continueShopping: e?.dataset.labelContinueShopping || `Continue shopping`,
			mobileVariant:
				e?.dataset.labelMobileVariant ||
				`Choose a variant on the product page.`,
		}),
		x = (e) => {
			let t = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);
			return (
				t.setAttribute(`viewBox`, `0 0 24 24`),
				t.setAttribute(`aria-hidden`, `true`),
				t.setAttribute(`focusable`, `false`),
				(t.innerHTML = e),
				t
			);
		},
		S = (e) => {
			let t = document.querySelector(`[data-product-tile-cart-drawer]`);
			return (
				t ||
				((t = document.createElement(`aside`)),
				(t.className = `product-tile-cart-drawer`),
				(t.dataset.productTileCartDrawer = ``),
				(t.hidden = !0),
				t.setAttribute(`aria-labelledby`, `ProductTileCartDrawerTitle`),
				(t.innerHTML = `
      <div class="product-tile-cart-drawer__scrim" data-product-tile-cart-close></div>
      <div class="product-tile-cart-drawer__panel" role="dialog" aria-modal="true" tabindex="-1">
        <div class="product-tile-cart-drawer__header">
          <h2 id="ProductTileCartDrawerTitle"></h2>
          <button class="product-tile-cart-drawer__close" type="button" data-product-tile-cart-close></button>
        </div>
        <div class="product-tile-cart-drawer__body" data-product-tile-cart-body></div>
        <div class="product-tile-cart-drawer__footer">
          <a class="product-tile-cart-drawer__checkout" href="${s()}"></a>
          <button class="product-tile-cart-drawer__continue" type="button" data-product-tile-cart-close></button>
        </div>
      </div>
    `),
				(t.querySelector(`h2`).textContent = e.cartTitle),
				t
					.querySelector(`.product-tile-cart-drawer__close`)
					.append(x(`<path d="M6 6L18 18M18 6L6 18"/>`)),
				t
					.querySelector(`.product-tile-cart-drawer__close`)
					.setAttribute(`aria-label`, e.closeCart),
				(t.querySelector(`.product-tile-cart-drawer__checkout`).textContent =
					e.checkout),
				(t.querySelector(`.product-tile-cart-drawer__continue`).textContent =
					e.continueShopping),
				t.addEventListener(`click`, (e) => {
					e.target.closest(`[data-product-tile-cart-close]`) && E();
				}),
				t.addEventListener(`keydown`, (e) => {
					e.key === `Escape` && E();
				}),
				document.body.append(t),
				t)
			);
		},
		C = (e, t = {}) => {
			let n = t.image || e.featured_image?.url || e.image,
				r = t.alt || e.featured_image?.alt || e.product_title || ``;
			return n
				? `<img class="product-tile-cart-drawer__image" src="${l(n)}" alt="${l(r)}" loading="lazy">`
				: `<span class="product-tile-cart-drawer__image product-tile-cart-drawer__image--empty"></span>`;
		},
		w = (e, t, n, r) => {
			let i = e.querySelector(`[data-product-tile-cart-body]`),
				a = n || t.items?.[0];
			i.innerHTML = a
				? `
        <p class="product-tile-cart-drawer__status">${e.dataset.labelAdded || ``}</p>
        <div class="product-tile-cart-drawer__item">
          <a class="product-tile-cart-drawer__media" href="${l(a.url || r.url || `#`)}">
            ${C(a, r)}
          </a>
          <div>
            <h3><a href="${l(a.url || r.url || `#`)}">${l(a.product_title || r.title)}</a></h3>
            ${a.variant_title ? `<p>${l(a.variant_title)}</p>` : ``}
            <p>${a.quantity || 1} x ${c(a.final_price, r.moneyFormat)}</p>
          </div>
        </div>
      `
				: ``;
		},
		T = (e, t, n, r = {}) => {
			let i = S(n);
			(i.dataset.labelAdded = n.added),
				w(i, e, t, r),
				(i.hidden = !1),
				document.documentElement.classList.add(`product-tile-cart-drawer-open`),
				i.querySelector(`[role="dialog"]`)?.focus();
		},
		E = () => {
			let e = document.querySelector(`[data-product-tile-cart-drawer]`);
			e &&
				((e.hidden = !0),
				document.documentElement.classList.remove(
					`product-tile-cart-drawer-open`,
				));
		},
		D,
		O = (e) => {
			let t = document.querySelector(`[data-product-tile-toast]`);
			t ||
				((t = document.createElement(`div`)),
				(t.className = `product-tile-toast`),
				(t.dataset.productTileToast = ``),
				t.setAttribute(`role`, `status`),
				t.setAttribute(`aria-live`, `polite`),
				document.body.append(t)),
				(t.textContent = e),
				(t.hidden = !1),
				t.classList.add(`is-visible`),
				clearTimeout(D),
				(D = window.setTimeout(() => {
					t.classList.remove(`is-visible`), (t.hidden = !0);
				}, 3200));
		},
		k = (e) =>
			i.get(e)?.overlay ||
			e.querySelector(`[data-product-tile-variant-overlay]`),
		A = (e, t) => {
			let n = [...e.querySelectorAll(t)],
				r = k(e);
			return r && !e.contains(r) && n.push(...r.querySelectorAll(t)), n;
		},
		j = (e, t) => {
			A(
				e,
				`[data-product-tile-quick-add], [data-product-tile-variant-option], [data-product-tile-overlay-add]`,
			).forEach((e) => {
				if (
					(e.setAttribute(`aria-busy`, String(t)),
					t
						? ((e.dataset.wasDisabled = String(!!e.disabled)),
							(e.disabled = !0))
						: e.dataset.wasDisabled !== void 0 &&
							((e.disabled = e.dataset.wasDisabled === `true`),
							delete e.dataset.wasDisabled),
					e.matches(`[data-product-tile-quick-add]`))
				) {
					if (t) {
						(e.dataset.idleAriaLabel = e.getAttribute(`aria-label`) || ``),
							e.setAttribute(`aria-label`, `${e.dataset.idleAriaLabel}…`);
						return;
					}
					e.dataset.idleAriaLabel !== void 0 &&
						(e.setAttribute(`aria-label`, e.dataset.idleAriaLabel),
						delete e.dataset.idleAriaLabel);
				}
			});
		},
		M = async (t, n, r = {}) => {
			if (a.has(t)) return;
			let i = b(t),
				o = document.activeElement,
				s = _(t),
				c = t.querySelector(`[data-cart-recommendation-error]`),
				l = new FormData();
			l.set(`id`, n),
				l.set(`quantity`, `1`),
				a.add(t),
				c && ((c.textContent = ``), (c.hidden = !0));
			try {
				await e(l, {
					onPending: (e) => j(t, e),
					openDrawer: async ({ addedItem: e, sectionHtml: n }) => {
						P(t);
						let a = {
							alt: r.productImageAlt,
							image: r.productImage,
							moneyFormat: t.dataset.moneyFormat || window.DifraxMoneyFormat,
							title: r.productTitle,
							url: r.productUrl,
						};
						if (window.DifraxCartDrawer?.openRendered) {
							await window.DifraxCartDrawer.openRendered(n, o, s);
							return;
						}
						T({ items: [e] }, e, i, a);
					},
				});
			} catch (e) {
				c
					? ((c.textContent = e?.message || i.cartError), (c.hidden = !1))
					: O(i.cartError);
			} finally {
				a.delete(t), j(t, !1);
			}
		},
		N = async (e) => {
			let t = k(e),
				n = t?.querySelector(`[role="dialog"]`);
			if (!t || !n) return;
			o && o !== e && P(o);
			let r = h(e),
				a = [...t.querySelectorAll(`[data-product-tile-variant-option]`)].find(
					(e) => e.dataset.variantId === String(r),
				);
			a && V(e, a),
				document.querySelector(`[data-cart-drawer].is-open`) &&
					(await window.DifraxCartDrawer?.close?.()),
				i.set(e, {
					nextSibling: t.nextSibling,
					overlay: t,
					parent: t.parentNode,
					trigger: document.activeElement,
				}),
				(o = e),
				document.body.append(t),
				(t.hidden = !1),
				document.documentElement.classList.add(
					`product-tile-variant-overlay-open`,
				),
				t.querySelectorAll(`[data-product-tile-complementary]`).forEach((e) => {
					window.requestAnimationFrame(() => U(e));
				}),
				n.focus();
		},
		P = (e) => {
			let t = i.get(e),
				n =
					t?.overlay || e.querySelector(`[data-product-tile-variant-overlay]`);
			n &&
				((n.hidden = !0),
				t?.parent && t.parent.insertBefore(n, t.nextSibling),
				i.delete(e),
				o === e && (o = null),
				document.documentElement.classList.remove(
					`product-tile-variant-overlay-open`,
				),
				t?.trigger?.focus?.());
		},
		F = (e, t) => {
			if (t.key !== `Tab`) return;
			let n = [
				...(k(e)?.querySelectorAll(
					`a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])`,
				) || []),
			].filter((e) => !e.hidden);
			if (!n.length) return;
			let r = n[0],
				i = n[n.length - 1];
			if (t.shiftKey && document.activeElement === r) {
				t.preventDefault(), i.focus();
				return;
			}
			!t.shiftKey &&
				document.activeElement === i &&
				(t.preventDefault(), r.focus());
		},
		I = (e) => {
			let t = k(e),
				n = [
					...(t?.querySelectorAll(`[data-product-tile-overlay-media-slide]`) ||
						[]),
				];
			return {
				dots: [
					...(t?.querySelectorAll(`[data-product-tile-overlay-media-dot]`) ||
						[]),
				],
				overlay: t,
				slides: n,
			};
		},
		L = (e, t) => {
			let { dots: n, slides: r } = I(e);
			if (!r.length) return;
			let i = ((t % r.length) + r.length) % r.length;
			r.forEach((e, t) => {
				let n = t === i;
				e.classList.toggle(`is-active`, n), (e.hidden = !n);
			}),
				n.forEach((e, t) => {
					let n = t === i;
					e.classList.toggle(`is-active`, n),
						e.setAttribute(`aria-selected`, String(n));
				});
		},
		R = (e) => {
			let { slides: t } = I(e),
				n = t.findIndex((e) => e.classList.contains(`is-active`) && !e.hidden);
			return n >= 0 ? n : 0;
		},
		z = (e, t) => {
			if (!t) return;
			let { slides: n } = I(e),
				r = n.findIndex((e) => e.dataset.mediaId === String(t));
			r >= 0 && L(e, r);
		},
		B = (e) => {
			let t = e.querySelector(`[data-product-tile-overlay-media-track]`);
			if (!t) return;
			let n = null,
				r = 0,
				i = 0,
				a = () => {
					(n = null), t.classList.remove(`is-swiping`);
				};
			t.addEventListener(`pointerdown`, (e) => {
				!e.isPrimary ||
					e.button !== 0 ||
					((n = e.pointerId),
					(r = e.clientX),
					(i = e.clientY),
					t.classList.add(`is-swiping`),
					t.setPointerCapture?.(e.pointerId));
			}),
				t.addEventListener(`pointerup`, (o) => {
					if (o.pointerId !== n) return;
					let s = o.clientX - r,
						c = o.clientY - i;
					t.releasePointerCapture?.(o.pointerId),
						a(),
						!(Math.abs(s) < 40 || Math.abs(s) <= Math.abs(c)) &&
							L(e, R(e) + (s < 0 ? 1 : -1));
				}),
				t.addEventListener(`pointercancel`, a),
				t.addEventListener(`lostpointercapture`, a);
		},
		V = (e, t) => {
			let n = k(e),
				r = n?.querySelector(`[data-product-tile-overlay-add]`),
				i = n?.querySelector(`[data-product-tile-overlay-price]`),
				a = n?.querySelector(`[data-product-tile-overlay-option-label]`),
				o = r?.querySelector(`[data-product-tile-overlay-add-text]`);
			if (
				(A(e, `[data-product-tile-variant-option]`).forEach((e) => {
					e.classList.toggle(`is-selected`, e === t);
				}),
				r)
			) {
				(r.dataset.variantId = t.dataset.variantId),
					(r.dataset.productTitle =
						t.dataset.productTitle || r.dataset.productTitle || ``),
					(r.dataset.productImage =
						t.dataset.productImage || r.dataset.productImage || ``),
					(r.dataset.productImageAlt =
						t.dataset.productImageAlt || r.dataset.productImageAlt || ``);
				let e = t.dataset.variantAvailable === `true`;
				(r.disabled = !e),
					o &&
						(o.textContent = e
							? r.dataset.availableText || o.textContent
							: r.dataset.soldOutText || `Sold out`);
			}
			m(e, t.dataset.variantId),
				i && t.dataset.variantPrice && (i.textContent = t.dataset.variantPrice),
				a && t.dataset.optionLabel && (a.textContent = t.dataset.optionLabel),
				z(e, t.dataset.variantMediaId);
		},
		H = (e, t) => {
			t.preventDefault();
			let n = t.submitter || e.querySelector(`[data-product-tile-quick-add]`),
				r = h(e);
			if (
				e.dataset.hasVariantChoices === `true` &&
				e.dataset.enableVariantPopup !== `false`
			) {
				N(e);
				return;
			}
			r && M(e, r, n?.dataset || {});
		},
		U = (e) => {
			let t = e.querySelector(`[data-product-tile-complementary-track]`),
				n = e.querySelector(`[data-product-tile-complementary-prev]`),
				r = e.querySelector(`[data-product-tile-complementary-next]`);
			if (!t || !n || !r) return;
			let i = t.scrollWidth - t.clientWidth;
			if (i <= 0 && t.clientWidth === 0) {
				(n.disabled = !1), (r.disabled = !1);
				return;
			}
			(n.disabled = t.scrollLeft <= 1),
				(r.disabled = i <= 1 || t.scrollLeft >= i - 1);
		},
		W = (e) => {
			let t = e.querySelector(`li`),
				n = t?.nextElementSibling;
			return t
				? n
					? n.getBoundingClientRect().left - t.getBoundingClientRect().left
					: t.getBoundingClientRect().width
				: e.clientWidth;
		},
		G = (e, t) => {
			let n = e.querySelector(`[data-product-tile-complementary-track]`);
			n && n.scrollBy({ behavior: `smooth`, left: W(n) * t });
		},
		K = (e) => {
			let t = e.querySelector(`[data-product-tile-complementary-track]`),
				n = e.querySelector(`[data-product-tile-complementary-prev]`),
				r = e.querySelector(`[data-product-tile-complementary-next]`);
			!t ||
				!n ||
				!r ||
				(n.addEventListener(`click`, () => G(e, -1)),
				r.addEventListener(`click`, () => G(e, 1)),
				t.addEventListener(`scroll`, () => U(e), { passive: !0 }),
				window.addEventListener(`resize`, () => U(e)),
				U(e));
		},
		q = (e) => {
			e.dataset.productTileInitialized !== `true` &&
				((e.dataset.productTileInitialized = `true`),
				e.addEventListener(`pointerenter`, () => d(e), { once: !0 }),
				e.addEventListener(`focusin`, () => d(e), { once: !0 }),
				e.querySelectorAll(`[data-product-tile-swatch]`).forEach((t) => {
					t.addEventListener(`click`, () => y(e, t));
				}),
				e
					.querySelector(`[data-cart-recommendation-variant]`)
					?.addEventListener(`change`, (t) => {
						g(e, t.currentTarget);
					}),
				e
					.querySelector(`[data-product-tile-quick-add]`)
					?.addEventListener(`click`, (t) => {
						H(e, t);
					}),
				e.querySelectorAll(`[data-product-tile-overlay-close]`).forEach((t) => {
					t.addEventListener(`click`, () => P(e));
				}),
				e
					.querySelector(`[data-product-tile-variant-overlay]`)
					?.addEventListener(`keydown`, (t) => {
						if (t.key === `Escape`) {
							P(e);
							return;
						}
						F(e, t);
					}),
				e
					.querySelectorAll(`[data-product-tile-variant-option]`)
					.forEach((t) => {
						t.addEventListener(`click`, () => V(e, t));
					}),
				e
					.querySelector(`[data-product-tile-overlay-media-prev]`)
					?.addEventListener(`click`, () => {
						L(e, R(e) - 1);
					}),
				e
					.querySelector(`[data-product-tile-overlay-media-next]`)
					?.addEventListener(`click`, () => {
						L(e, R(e) + 1);
					}),
				e
					.querySelectorAll(`[data-product-tile-overlay-media-dot]`)
					.forEach((t, n) => {
						t.addEventListener(`click`, () => L(e, n));
					}),
				B(e),
				e
					.querySelector(`[data-product-tile-overlay-add]`)
					?.addEventListener(`click`, (t) => {
						let n = t.currentTarget;
						n.dataset.variantId && M(e, n.dataset.variantId, n.dataset);
					}),
				e.querySelectorAll(`[data-product-tile-complementary]`).forEach(K));
		},
		J = (e = document) => {
			e.matches?.(t) && q(e), e.querySelectorAll?.(t).forEach(q), v();
		};
	window.DifraxProductTiles = { init: J };
	let Y = window.Difrax?.sectionLifecycle;
	Y
		? Y.register({
				name: `product-tile`,
				selector: t,
				init(e) {
					q(e), v();
				},
			})
		: document.readyState === `loading`
			? document.addEventListener(`DOMContentLoaded`, () => J())
			: J(),
		document.addEventListener(`shopify:section:load`, (e) => J(e.target));
})();
